import React, { useEffect, useState } from "react";

export default function AdminSocialMediaDialog({ open, onClose, onSave, initial = null, isSaving = false }) {
  const [form, setForm] = useState({
    platform: "",
    handle: "",
    url: "",
    description: "",
    followers: "",
    color: "",
    iconFile: null,
    active: false,
  });

  useEffect(() => {
    if (initial) {
      setForm({
        platform: initial.platform || "",
        handle: initial.handle || "",
        url: initial.url || "",
        description: initial.description || "",
        followers: initial.followers || "",
        color: initial.color || "",
        iconFile: null,
        active: !!initial.active,
      });
    } else {
      setForm({ platform: "", handle: "", url: "", description: "", followers: "", color: "", iconFile: null, active: false });
    }
  }, [initial, open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const handleFile = (e) => {
    const f = e.target.files && e.target.files[0];
    setForm((s) => ({ ...s, iconFile: f }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSaving) return;
    const fd = new FormData();
    fd.append("platform", form.platform || "");
    fd.append("handle", form.handle || "");
    fd.append("url", form.url || "");
    fd.append("description", form.description || "");
    fd.append("followers", form.followers || "");
    fd.append("color", form.color || "");
    fd.append("active", form.active ? "true" : "false");
    if (form.iconFile) fd.append("icon", form.iconFile);
    onSave(fd);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-start justify-center z-50 p-4 sm:items-center">
      <div className="relative bg-white rounded shadow-lg w-full max-w-xl p-6 max-h-[90vh] overflow-y-auto">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-3xl font-bold leading-none"
          aria-label="Close dialog"
        >
          &times;
        </button>
        <h2 className="text-xl font-semibold mb-4">{initial ? "Edit Social Media" : "Add Social Media"}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Platform</label>
            <input name="platform" value={form.platform} onChange={handleChange} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Handle</label>
            <input name="handle" value={form.handle} onChange={handleChange} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">URL</label>
            <input name="url" value={form.url} onChange={handleChange} className="w-full border rounded p-2" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} className="w-full border rounded p-2" />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Followers</label>
              <input name="followers" value={form.followers} onChange={handleChange} className="w-full border rounded p-2" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Color</label>
              <input name="color" value={form.color} onChange={handleChange} className="w-full border rounded p-2" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Icon (optional)</label>
            <input type="file" accept="image/*" onChange={handleFile} />
          </div>

          <div className="flex items-center gap-3">
            <label className="flex items-center gap-2"><input type="checkbox" name="active" checked={form.active} onChange={handleChange} /> Active</label>
          </div>

          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} className="px-4 py-2 border rounded" disabled={isSaving}>Cancel</button>
            <button type="submit" className={`px-4 py-2 rounded text-white ${isSaving ? "bg-blue-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`} disabled={isSaving}>
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
